import { render, staticRenderFns } from "./InvoiceFee.vue?vue&type=template&id=48b0bff0&scoped=true&"
import script from "./InvoiceFee.vue?vue&type=script&lang=ts&"
export * from "./InvoiceFee.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceFee.vue?vue&type=style&index=0&id=48b0bff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0bff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSelect,VSimpleTable})
